import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import TitleSection from '../components/Reusable/TitleSection';
import ContentSection from '../components/Reusable/MDContectSecition';
import MarkdownProcessor from '../components/Reusable/MarkdownProcessor';
import FoxViewer from '../components/FiberElements/FoxViewer';

// 🔹 Estilo global para toda la página
const GlobalStyle = createGlobalStyle`
  html, body {
    font-family: 'Merriweather', serif;
    background: #ffffff;
    color: #111111;
    margin: 0;
    padding: 0;
  }
  
  h1, h2, h3, h4 {
    font-family: 'Merriweather', serif;
    font-weight: bold;
  }
  
  p, li, span {
    font-family: 'Merriweather', serif;
    font-size: 1em;
    line-height: 1.6;
  }
`;

// Contenedor principal para añadir algo de padding
const PageWrapper = styled.div`
  padding: 20px;
`;

const Home = () => {
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);

  useEffect(() => {
    document.title = "Guía - Nuestra Plataforma";
  }, []);

  const handleContentProcessed = (processedSections) => {
    setSections(processedSections);
    if (processedSections.length > 0) {
      setSelectedSection(processedSections[0].id);
    }
  };

  const handleMenuClick = (id) => {
    setSelectedSection(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <PageWrapper>
      <GlobalStyle />
      <FoxViewer />

      {/* Carga y procesa el contenido del Markdown */}
      <MarkdownProcessor
        url="https://raw.githubusercontent.com/AppsDevsLeon/metamask-start-guide/refs/heads/main/readme_es.md"
        onContentProcessed={handleContentProcessed}
      />

      {sections.length > 0 && (
        <>
          {sections.map(({ id, title, content }) => (
            <div key={id} id={id}>
              <TitleSection title={title} />
              <ContentSection sections={[{ id, title, content }]} />
            </div>
          ))}
        </>
      )}
    </PageWrapper>
  );
};

export default Home;
